import { makeStyles } from '@material-ui/core';

interface StylesProps {
  colorHeader: string;
}

export const useStyles = makeStyles((theme) => ({
  
  container: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    paddingBottom: '0px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '8px',
    background: '#FFF',
  },

  header:(props: StylesProps) => ({
    width: 'calc(100vw - 20px)',
    height: '74px',
    margin:'10px',
    borderRadius: '8px',
    background: props.colorHeader,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'left', /* Centrado horizontal */
    alignItems: 'center',
    '& > img ': {
      width: '30%',
      height: 'auto',
    },
    
  }),
  body: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    width:'100%',
    backgroundColor: '#fff',
  },
  scroll:{
    overflowY: "scroll",
  },
    titles:{
      alignSelf: 'stretch',
      display: 'flex',
      width: '100%',
      padding: '10px',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
      title:{
        color:  '#104B71',
        /* M3/title/medium */
        fontFamily: 'Antonia H3',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal', /* 150% */
        letterSpacing: '-0.72px',

      },
      bloqueText:{
        padding:'36px',
        '& > a ': {
        color: '#014951)',
        textAlign: 'center',
        /* H5 Bold */
        fontFamily: 'Work Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '24px', /* 171.429% */
        letterSpacing: 'x-0.42px',
        }
      },
      subtitle:{
        color: '#272727',
        /* M3/label/medium - prominent */
        fontFamily: 'Work Sans',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '26px', /* 133.333% */
        letterSpacing: '-0.54px',
        '& > span ': {
          color:'#104B71',
          lineHeight: '28px',
          fontSize: '20px',
          fontWeight: 500,
          letterSpacing: '-0.6px',
          paddingBottom:'0px',
        },
        
    },
    line:{
      width: '100%', /* Ajusta el ancho de la línea horizontal según tus necesidades */
      border: '0',
      borderTop: '2px solid black', /* Ajusta el estilo según tus necesidades */
      opacity: '0.2',
      background: '#606060',
      margin:'10px 0 10px 0'
    },

  content: {
    flex:2,
    display: 'flex',
    width: '100%',
    height: 'auto',
    paddingBottom: '0px',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#FFF',
    alignItems: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '600px',
    margin: '0 auto',
    padding: theme.spacing(2),
  },
  row: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  inputL: {
    marginRight: theme.spacing(2),
    flex: 1,
  },
  inputR: {
    flex: 1,
  },

  footer: {
    backgroundColor: '#FFF',
    color: 'white',
    textAlign: 'center',
    width:'100%'
  },

  buttons:{
    width: '100%',
    display: 'grid',
    padding: '16px',
    
  },
  information:{
    display: 'flex',
    padding: '16px 10px 20px 10px',
    flexDirection: 'column',
    alignItems: 'center',
    gap:'10px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: '#E2F7FE',
    marginBottom:'40px'
  },
  information1:{
    alignSelf: 'stretch',
    color: '#2E95BB',
    textAlign: 'center',
    /* Heading/Heading 06/Bold */
    fontFamily: 'Work Sans',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '13px', /* 130% */
  },
  information2:{
    alignSelf: 'stretch',
    color: '#003C3C',
    textAlign: 'center',
    /* Heading/Heading 06/Medium */
    fontFamily: 'Work Sans',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '140%', /* 14px */
    letterSpacing: '-0.3px',
    '& > a ': {
      color: '#2E95BB',
      /* Heading/Heading 06/Bold */
      fontFamily: 'Work Sans',
      fontSize: '10px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '13px',
    },
  }

}));
